<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M16 8.04883C16 3.63083 12.418 0.0488281 8 0.0488281C3.582 0.0488281 0 3.63083 0 8.04883C0 12.0422 2.92533 15.3515 6.75 15.9515V10.3615H4.71867V8.04816H6.75V6.28683C6.75 4.28216 7.94467 3.17416 9.772 3.17416C10.6467 3.17416 11.5627 3.33083 11.5627 3.33083V5.29949H10.5533C9.55933 5.29949 9.24933 5.91616 9.24933 6.54883V8.04883H11.468L11.1133 10.3622H9.24933V15.9522C13.0747 15.3515 16 12.0415 16 8.04883Z"
			fill="#1877F2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconFacebook',
	props: {
		size: {
			type: [Number, String],
			default: 16
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	}
}
</script>
